import React from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Radio, Spin } from 'antd'

const QUERY = gql`
  query GetCustomerShippingAddresses($customerId: String!, $defaultFormCart: ID, $customerCompanyId: ID) {
    customer(customerNo: $customerId) {
      id
      cartDefaultShippingAddress(id: $defaultFormCart, customerCompanyId: $customerCompanyId) {
        id
        provinceId
        districtId
      }
      cartShippingAddresses(customerCompanyId: $customerCompanyId) {
        id
        provinceId
        districtId
        fullAddress
      }
    }
  }
`

const dataParser = customer => {
  if (!customer) return []

  const { cartShippingAddresses } = customer

  return cartShippingAddresses.reduce(({ options, addresses }, address) => {
    return {
      options: [...options, { label: address.fullAddress, value: address.id }],
      addresses: [...addresses, {
        id: address.id,
        provinceId: address.provinceId,
        districtId: address.districtId
      }]
    }
  }, { options: [], addresses: [] })
}

const CartShippingAddresses = ({
  customerId,
  defaultFormCart,
  customerCompanyId,
  onChange,
  selected
}) => {
  const { data, loading, error } = useQuery(QUERY, {
    variables: { customerId, defaultFormCart, customerCompanyId },
    onCompleted: ({ customer }) => {
      const address = customer.cartDefaultShippingAddress
      if (!address) return null

      if (!selected || address.id !== selected.id) {
        onChange(address)
      }
    }
  })

  if (error) { console.error(error) }
  if (loading) return <Spin />

  const { addresses, options } = dataParser(data.customer)

  const handleChange = event => {
    const address = addresses.find(address => address.id === event.target.value)

    onChange(address)
  }

  return (
    <Radio.Group
      onChange={handleChange}
      options={options}
      value={selected ? selected.id : null}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }} />
  )
}

CartShippingAddresses.propTypes = {
  customerId: PropTypes.string.isRequired,
  defaultFormCart: PropTypes.string,
  customerCompanyId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.object
}

export default CartShippingAddresses
